<div class="billling-wrapper" *transloco="let t">
  <div class="centeredBoxText">
    <h4>{{ t("register.form.billingContact.title-1") }}</h4>
  </div>
  <app-text-input
    [rowId]="1"
    [reference]="(billingContact().billingOrgName$ | async) ?? ''"
    (referenceChange)="billingContact().billingOrgName = $event"
    [translateDescriptionBaseKey]="'settings.form.orgname'"
    [descriptionBaseKey]="'settings.form.orgname'"
    #billingOrgNameValidationMessage="appValidationMessage"
    [appValidationMessage]="billingContact().formValidator.watchKey$('billingOrgName') | async"
    (click)="billingOrgNameValidationMessage.hide()"
    [mandatory]="true"
    [disabled]="disabled()"
  />

  <app-text-input
    [rowId]="1"
    [reference]="(billingContact().email$ | async) ?? ''"
    (referenceChange)="billingContact().email = $event"
    [translateDescriptionBaseKey]="'global.form.email'"
    [descriptionBaseKey]="'global.form.email'"
    #emailValidationMessage="appValidationMessage"
    [appValidationMessage]="billingContact().formValidator.watchKey$('email') | async"
    (click)="emailValidationMessage.hide()"
    [mandatory]="true"
    [disabled]="disabled()"
  />

  <app-text-input
    [rowId]="1"
    [reference]="(billingContact().firstName$ | async) ?? ''"
    (referenceChange)="billingContact().firstName = $event"
    [translateDescriptionBaseKey]="'register.form.billingContact.firstname'"
    [descriptionBaseKey]="'register.form.billingContact.firstname'"
    #firstNameValidationMessage="appValidationMessage"
    [appValidationMessage]="billingContact().formValidator.watchKey$('firstName') | async"
    (click)="firstNameValidationMessage.hide()"
    [mandatory]="true"
    [disabled]="disabled()"
  />

  <app-text-input
    [rowId]="1"
    [reference]="(billingContact().lastName$ | async) ?? ''"
    (referenceChange)="billingContact().lastName = $event"
    [translateDescriptionBaseKey]="'register.form.billingContact.lastname'"
    [descriptionBaseKey]="'register.form.billingContact.lastname'"
    #lastNameValidationMessage="appValidationMessage"
    [appValidationMessage]="billingContact().formValidator.watchKey$('lastName') | async"
    (click)="lastNameValidationMessage.hide()"
    [mandatory]="true"
    [disabled]="disabled()"
  />

  <app-text-input
    [rowId]="1"
    [reference]="(billingContact().department$ | async) ?? ''"
    (referenceChange)="billingContact().department = $event"
    [translateDescriptionBaseKey]="'register.form.billingContact.billingDepartment'"
    [descriptionBaseKey]="'register.form.billingContact.billingDepartment'"
    [mandatory]="false"
    [disabled]="disabled()"
  />

  <app-text-input
    [rowId]="1"
    [reference]="(billingContact().street$ | async) ?? ''"
    (referenceChange)="billingContact().street = $event"
    [translateDescriptionBaseKey]="'settings.form.orgStreet'"
    [descriptionBaseKey]="'settings.form.orgStreet'"
    #streetValidationMessage="appValidationMessage"
    [appValidationMessage]="billingContact().addressFormValidator.watchKey$('street') | async"
    (click)="streetValidationMessage.hide()"
    [mandatory]="true"
    [disabled]="disabled()"
  />

  <app-text-input
    [rowId]="1"
    [reference]="(billingContact().zipCode$ | async) ?? ''"
    (referenceChange)="billingContact().zipCode = $event"
    [translateDescriptionBaseKey]="'settings.form.orgZipcode'"
    [descriptionBaseKey]="'settings.form.orgZipcode'"
    #zipCodeValidationMessage="appValidationMessage"
    [appValidationMessage]="billingContact().addressFormValidator.watchKey$('zipCode') | async"
    (click)="zipCodeValidationMessage.hide()"
    [mandatory]="true"
    [disabled]="disabled()"
  />

  <app-text-input
    [rowId]="1"
    [reference]="(billingContact().place$ | async) ?? ''"
    (referenceChange)="billingContact().place = $event"
    [translateDescriptionBaseKey]="'register.form.billingContact.orgPlaceBilling'"
    [descriptionBaseKey]="'register.form.billingContact.orgPlaceBilling'"
    #placeValidationMessage="appValidationMessage"
    [appValidationMessage]="billingContact().addressFormValidator.watchKey$('place') | async"
    (click)="placeValidationMessage.hide()"
    [mandatory]="true"
    [disabled]="disabled()"
  />
</div>
